import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  styled
} from '@mui/material';

// Styled components using Material UI's styled API
const StyledSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(8, 0),
  backgroundColor: theme.palette.background.default,
}));

const DecorativeSvg = styled('svg')(({ theme }) => ({
  position: 'absolute',
  opacity: 0.2,
  stroke: theme.palette.text.primary,
  strokeWidth: 2,
}));

const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
  color: theme.palette.common.white,
  fontWeight: 600,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1, 3),
  '&:hover': {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
  },
  transition: 'all 0.3s ease',
}));

// Main component
export const BlogResources = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Latest Drone Technology Trends",
      snippet: "Stay updated on the newest advancements in drone technology and how they can benefit your business.",
      image: "./blog1.png",
      
    },
    {
      id: 2,
      title: "Drone Safety and Regulations",
      snippet: "Learn about the latest drone regulations and best practices to ensure safe and compliant operations.",
      image: "./blog2.png",
    
    },
    {
      id: 3,
      title: "Maximizing ROI with Drone Services",
      snippet: "Discover how drone services can help boost your business efficiency and return on investment.",
      image: "./blog3.png",
      
    },
  ];

  return (
    <StyledSection component="section">
      {/* Decorative Elements */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none'
      }}>
        <DecorativeSvg sx={{ top: 40, left: 40 }} width="100" height="100" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
        </DecorativeSvg>
        <DecorativeSvg sx={{ bottom: 40, right: 40 }} width="100" height="100" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
        </DecorativeSvg>
      </Box>

      <Box sx={{
        maxWidth: '1200px',
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative',
        zIndex: 10
      }}>
        {/* Heading with Gradient Text */}
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2.25rem', md: '3rem' },
            fontWeight: 'bold',
            mb: 6, // Reduced margin bottom
            animation: 'fadeIn 1s ease-in'
          }}
        >
          Blog & <Box component="span" sx={{ color: '#027bff' }}>Resources</Box>
        </Typography>

        {/* Blog Posts Grid */}
        <Grid container spacing={4} sx={{ px: 4 }}>
          {blogPosts.map((post) => (
            <Grid item xs={12} md={4} key={post.id}>
              <Card sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 4,
                boxShadow: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 6
                }
              }}>
                {/* Image with Overlay */}
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    image={post.image}
                    alt={post.title}
                    sx={{ height: 240, objectFit: 'cover' }}
                  />
                  <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'common.black',
                    opacity: 0.2
                  }} />
                </Box>

                {/* Content */}
                <CardContent sx={{ flexGrow: 1, p: 4 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 600, mb: 2 }}>
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      mb: 3,
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                  >
                    {post.snippet}
                  </Typography>
                  {/* <Link to={post.link} style={{ textDecoration: 'none' }}>
                    <GradientButton variant="contained">
                      Read Our Blog
                    </GradientButton>
                  </Link> */}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledSection>
  );
};
